import { render } from "./create_service_modal.vue?vue&type=template&id=09c66d89&scoped=true"
import script from "./create_service_modal.vue?vue&type=script&lang=js"
export * from "./create_service_modal.vue?vue&type=script&lang=js"

import "./create_service_modal.vue?vue&type=style&index=0&id=09c66d89&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c66d89"]])

export default __exports__